import { atomWithStorage } from 'jotai/utils';
import { ATOM_DARK_MODE_KEY } from './atomConstants';

const defaultMode = window?.matchMedia('(prefers-color-scheme: dark)').matches;

export const isDarkModeAtom = atomWithStorage<boolean>(ATOM_DARK_MODE_KEY, defaultMode, undefined, {
    getOnInit: true
});
